import React from "react";

const InstalacionesMessage = ({payload}) => {
    const {instalaciones} = payload;

    return (
        <div>
            {instalaciones.map((instalacion, index) => (
                <div key={index} style={{
                    marginBottom: "10px",
                    marginLeft: "50px",
                    paddingLeft: "10px",
                    padding: "5px",
                    borderRadius: "5px",
                    background: "#d90e75",
                    color: "#fff",
                    fontSize: "0.9rem",
                }}>
                    <strong>Instalación {index + 1}:</strong>
                    <div>-
                        <strong>Fecha:</strong> {new Intl.DateTimeFormat("es-MX", {dateStyle: "long"}).format(new Date(instalacion.Fecha_Cierre))}
                    </div>
                    <div>-
                        <strong>Paquete:</strong> {instalacion.Paquete_Contratado}
                    </div>
                    <div>-
                        <strong>Estado:</strong> {instalacion.Subestado}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default InstalacionesMessage;
